const KONTIST = 'kontist'

export const isBankKontist = (bankName: string): boolean => {
  return bankName.toLowerCase() === KONTIST
}
